<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-icon>list</v-icon>
                  <v-toolbar-title>Requisition Listing</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items v-if="roles.auth_role">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on">
                          <v-icon>add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Add Template</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12>

                        <v-expansion-panel>
                          <v-expansion-panel-content style="background-color: #bacccc;">
                            <template v-slot:header>
                              <div style="font-size: medium;">Filter Panel</div>         
                            </template>

                            <v-container class="pt-0">
                              <v-layout row wrap>
                                <v-flex class="text-xs-right">
                                  <v-btn color="orange" small fab @click="selected_filter.push({field:'', value:'', type:''})"><v-icon color="white">add</v-icon></v-btn>
                                  <v-btn color="green" @click="refreshData()">GENERATE NOW</v-btn>
                                  <v-btn color="cyan lighten-1" @click="selected_filter=[], refreshData()">RESET FILTER</v-btn>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex>
                                  <v-card>
                                    <v-card-text v-if="selected_filter.length > 0">
                                      <v-container>
                                        <v-layout row wrap
                                          v-for="(item,i) in selected_filter"
                                          :key="i"
                                        >                                
                                          <v-flex xs12 md5>
                                            <v-select
                                              v-model="selected_filter[i].field"
                                              :items="get_filterable_columns"
                                              @change="d_onchange(selected_filter[i])"
                                              clearable
                                              item-text="text"
                                              item-value="value"
                                              label="select field"
                                            ></v-select>
                                          </v-flex>
                                          <v-flex xs12 md1 class="text-md-center">
                                            contains
                                          </v-flex>
                                          <v-flex xs12 md5>
                                            <v-text-field
                                              v-model="selected_filter[i].value"
                                              label="your text"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md1>
                                            <v-layout justify-space-around class="mb-2">
                                              <span class="group pa-2">
                                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>
                                                
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-data-table
                          :headers="table.headers.filter(el=>el.visible == true)"
                          :items="table.items"
                          :loading="table.loading"
                          must-sort
                          :pagination.sync="table.pagination"
                          :rows-per-page-items="table.rows_per_page_items"
                          :total-items="table.total_items"
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item._id }}</td>
                            <td class="pa-1">{{ props.item.hub }}</td>
                            <td class="pa-1" v-if="roles.auth_role">{{ props.item.dept }}</td>
                            <td class="pa-1">{{ props.item.name }}</td>
                            <td class="pa-1">{{ props.item.remark }}</td>
                            <td class="pa-1" v-if="roles.auth_role">{{ props.item.created_by }}</td>
                            <td class="pa-1" v-if="roles.auth_role">{{ epoch2localedatetime(props.item.created) }}</td>
                            <td class="pa-1" v-if="roles.auth_role">{{ props.item.modified_by }}</td>
                            <td class="pa-1" v-if="roles.auth_role">{{ epoch2localedatetime(props.item.modified) }}</td>
                            <td class="pa-1">{{ props.item.status }}</td>
                            <td class="pa-1">
                              <v-menu bottom left offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon v-on="on">
                                    <v-icon color="primary">more_vert</v-icon>
                                  </v-btn>
                                </template>
                                
                                <v-list dense class="pa-0">
                                  <v-list-tile @click="editRecord_onClick(props.item)" v-if="roles.auth_role">
                                    <v-list-tile-action><v-icon small left>edit</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Edit</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile :href="'req_applicants_listing?pageid=226&reqid=' + props.item._id" v-if="roles.auth_role && getCurrentStatusOrder(props.item.g_status_id)>1">
                                    <v-list-tile-action><v-icon small left>people_alt</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Candidate List</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile :href="'req_applicants_crud?pageid=227&email_invi=0&_id=&reqid=' + props.item._id" v-if="getCurrentStatusOrder(props.item.g_status_id)==2">
                                    <v-list-tile-action><v-icon small left>pan_tool_alt</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Apply Now</v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile :href="'req_log?pageid=356&Lev=&Lso=' + props.item._id" v-if="roles.auth_role">
                                    <v-list-tile-action><v-icon small left>list</v-icon></v-list-tile-action>
                                    <v-list-tile-title>Activity Log</v-list-tile-title>
                                  </v-list-tile>
                                </v-list>
                              </v-menu>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- START dialog -->
          <v-dialog
            v-model="dialog.visible"
            persistent
            scrollable
            max-width="600px"
          >
            <v-card>
              <v-card-title class="headline pb-0">
                {{ dialog.title }} Requisition
              </v-card-title>

              <v-card-text>
                <v-form ref="MainForm">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          :readonly="getCurrentStatusOrder(selected.g_status_id)>1"
                          :style="{ backgroundColor: getCurrentStatusOrder(selected.g_status_id)>1 ? '#f5f5f5' : 'white' }"
                          :rules="[rules.required]"
                          v-model="selected.name"
                          label="Req. Name"
                          type="text"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-select
                          :readonly="getCurrentStatusOrder(selected.g_status_id)>1"
                          :style="{ backgroundColor: getCurrentStatusOrder(selected.g_status_id)>1 ? '#f5f5f5' : 'white' }"
                          :rules="[rules.required]"
                          :items="hubs"
                          v-model="selected.hub"
                          item-text="display_text"
                          item-value="name"
                          label="Company"
                          @change="hub_onchange($event)"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12>
                        <v-select
                          :readonly="readonly || getCurrentStatusOrder(selected.g_status_id)>1"
                          :style="{ backgroundColor: readonly || getCurrentStatusOrder(selected.g_status_id)>1 ? '#f5f5f5' : 'white' }"
                          :rules="[rules.required]"
                          :items="dept_by_hub"
                          v-model="selected.dept"
                          item-text="display_text"
                          item-value="name"
                          label="Department"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12>
                        <v-textarea
                          :readonly="getCurrentStatusOrder(selected.g_status_id)>1"
                          :style="{ backgroundColor: getCurrentStatusOrder(selected.g_status_id)>1 ? '#f5f5f5' : 'white' }"
                          v-model="selected.remark"
                          label="Remark"
                          hint="Max 1000 characters."
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs12>
                        <v-textarea
                          :readonly="getCurrentStatusOrder(selected.g_status_id)>1"
                          :style="{ backgroundColor: getCurrentStatusOrder(selected.g_status_id)>1 ? '#f5f5f5' : 'white' }"
                          v-model="selected.notes"
                          label="Notes (for internal used, public not visible)"
                          hint="Max 1000 characters."
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs12>
                        <v-select
                          readonly
                          :style="{ backgroundColor: '#f5f5f5'}"
                          :items="status_option"
                          v-model="selected.g_status_id"
                          item-text="label"
                          item-value="_id"
                          label="Status"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions v-if="roles.auth_role">
                <v-spacer></v-spacer>
                <v-btn color="orange" flat @click="dialog.visible = false">
                  Cancel
                </v-btn>
                <v-btn color="blue" flat @click="setActive_onClick()" v-if="selected.g_status_id==(status_option[0]?status_option[0]._id:true) && selected._id">
                  Set Active
                </v-btn>
                <v-btn color="blue" flat @click="setInactive_onClick()" v-if="getCurrentStatusOrder(selected.g_status_id)==2">
                  Set Inactive
                </v-btn>
                <v-btn color="green" flat @click="save_onClick()" v-if="getCurrentStatusOrder(selected.g_status_id)<2">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->

        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
import query_builder from "../../functions/query.builder";

export default {
  name: "req_listing", // copy code from doc_template
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      selected_filter: [],
      rules: {
				required: (value) => !!value || "This field required.",
				greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
			},
      table: {
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "#ID",
            class: "pa-1 pl-3",
            value: "_id",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Comp",
            class: "pa-1",
            value: "hub",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Dept",
            class: "pa-1",
            value: "dept",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: false //this.isLogin
          },
          {
            text: "Req. Name",
            class: "pa-1",
            value: "name",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Remark",
            class: "pa-1",
            value: "remark",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Created By",
            // align: "left",
            class: "pa-1",
            value: "created_by",
            filterable: true,            
            sortable: true,
            data_type: "String",
            visible: false //this.isLogin
          },
          {
            text: "Created DateTime",
            // align: "left",
            class: "pa-1",
            value: "created",
            filterable: false,            
            sortable: true,
            data_type: "Date",
            visible: false //this.isLogin
          },
          {
            text: "Modified By",
            // align: "left",
            class: "pa-1",
            value: "modified_by",
            filterable: true,            
            sortable: true,
            data_type: "String",
            visible: false //this.isLogin
          },
          {
            text: "Modified DateTime",
            // align: "left",
            class: "pa-1",
            value: "modified",
            filterable: false,            
            sortable: true,
            data_type: "Date",
            visible: false //this.isLogin
          },
          {
            text: "Status",
            // align: "left",
            class: "pa-1",
            value: "status",
            filterable: true,            
            sortable: true,
            data_type: "String",
            visible: true
          }
        ],
				items: [],
				total_items:0,
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 10,
					sortBy: "_id",
					totalItems: 100
				},
      },
      dialog: {
        visible: false,
        title: ""
      },
      status_option: [],
      hubs: [],
      departments: [],
      dept_by_hub: [],
      readonly: true,
      selected: {
				_id: "",
        name: "",
        remark: "",
        g_status_id: "",
        hub: "",
        dept: "",
        notes: ""
      },
      roles: {
        roles: [],
        auth_role: false
      },
      hide_filter: ["Dept", "Created By", "Modified By"]
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    }
    // "selected_filter":{
    //   handler:function(){
    //     console.log(this.selected_filter);
    //   }
    // }
  },
  async mounted() {
    common.App.set_page_title("mySuite: Requisition");

    this.username = auth.getUsername();
		this.status_option = await common.App.arango_app_selections("requisition", "status");

    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
      res = res.data;
      if (res.Status == 1) {
        this.roles.roles = res.Body;
      } else {
        common.wMsgBox.Error(res.Description);
      }
    
    this.roles.auth_role = common.App.check_role(this.roles.roles, 7);

    if (this.roles.auth_role) {
      this.table.headers = this.table.headers.map(el=>{el.visible=true; return el});
    } else {
      this.table.headers = this.table.headers.map(el=>{ 
        if (this.hide_filter.includes(el.text)) {
          el.filterable = false;
        } 
          return el;
      });
    }
        
    // get hub list
    res = await common.wBackEndComm.GetData("mycareer/pub_get_hub_list/");
      res = res.data;
      if (res.Status == 1) {
        let temp_hubs = res.Body.records;
        temp_hubs = this.sort_arr(temp_hubs, "g_status_id__value", "name");
        this.hubs = this.compute_display_text(temp_hubs);
      } else {
        common.wMsgBox.Error(res.Description);
      }

    // get dept list
    res = await common.wBackEndComm.GetData("mycareer/pub_get_dept_list/");
      res = res.data;
      if (res.Status == 1) {
        let temp_departments = res.Body.records;
        temp_departments = this.sort_arr(temp_departments, "g_status_id__value", "name");
        this.departments = this.compute_display_text(temp_departments);
      } else {
        common.wMsgBox.Error(res.Description);
      }
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
    d_onchange(ind){
      var temp = this.table.headers.find(el => el.value == ind.field);
      ind.type = temp.data_type;
    },
    async refreshData() {
			// this.table.loading = true;
      common.App.loader.show(this);

			var qb = new query_builder.QueryBuilder();

			qb.Table = "requisition_listing";
			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					}
				];
			}

      let filter_len = this.selected_filter.length;

      if (filter_len>0) {

        for (let i =0; i<filter_len; i++) {
          let rule = new query_builder.Rule();

          switch(this.selected_filter[i].type) {
            case "String":
              rule
                .field(this.selected_filter[i].field)
                .operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
                .value(this.selected_filter[i].value);
              break;
  
            case "Number":
              break;
  
            case "Date":
              break; 
          }
          qb.Where.rules.push(rule);
        }
      }

			var res = await common.wBackEndComm.PostData("mycareer/requisition_listing/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				common.wMsgBox.Error(res.Description);
			}

			// this.table.loading = false;
      common.App.loader.hide(this);
    },
    addNewRecord_onClick() {
      this.dialog.visible = true;
      this.dialog.title = "Create";

      this.$refs.MainForm.resetValidation();

      this.selected = {
        _id: "",
        name: "",
				g_status_id: this.status_option[0]._id,
        remark: "",
        hub: "",
        dept: "",
        notes: "",
      };

      this.dept_by_hub = [];
      this.readonly = true;
    },
    editRecord_onClick(item) {
      this.dialog.visible = true;
      this.dialog.title = "Modifying ";
			
      this.$refs.MainForm.resetValidation();
      
      this.selected = {
        _id: item["_id"],
        name: item["name"],
        g_status_id: item["g_status_id"],
        remark: item["remark"],
        hub: item["hub"],
        dept: item["dept"],
        notes: item["notes"]
      };

      this.hub_onchange(this.selected.hub);
    },
    viewMenu() {
      this.showMenu = true;
    },
    async save_onClick() {
			common.App.loader.show(this);

			if (this.$refs.MainForm.validate()) {
				var url = "mycareer/requisition_crud/";

				var result = await common.wBackEndComm.PostData(url, this.selected);
				result = result.data;

				if (result.Status == 1) {
					this.selected = result.Body;

					// if (new_rec) {
					// 	window.history.pushState({}, null, "/FPES-report?_id=" + this.selected._id);
					// }
					common.wMsgBox.Success(result.Description);
          this.dialog.visible = false;
          this.refreshData();

				} else {
					common.wMsgBox.Error(result.Description);
				}
			} else {
				common.wMsgBox.Error(
					"Please fill in all required fields before click on save button."
				);
			}
			common.App.loader.hide(this);
    },
    setActive_onClick() {
      this.selected.g_status_id = this.status_option[1]._id;
      this.save_onClick();
    },
    setInactive_onClick() {
      this.selected.g_status_id = this.status_option[2]._id;
      this.save_onClick();
    },
    getCurrentStatusOrder(cur_status_id) {
      var val = null;      
      var obj = this.status_option.find(function(el){
        return el._id==cur_status_id;
      });

      if (obj){
        val = obj.order;
      }

      return val;
    },
    sort_arr(arr, sort_prop1, sort_prop2) {
      return arr.sort((a, b) => a[sort_prop1].localeCompare(b[sort_prop1]) || b[sort_prop2] - a[sort_prop2]);
    },
    compute_display_text(arr) {      
      arr.forEach(function(arr){
        if (arr.g_status_id__value.includes("Inactive")){
          arr.display_text = "(x) " + arr.name;
        } else {
          arr.display_text = arr.name;
        }
      });
      return arr;
    },
    hub_onchange(e) {
      this.readonly = true;

      this.dept_by_hub = this.departments.filter(obj => {
        return obj.company_id__name === e;
      });

      // check this => to reset readonly = true after dialog off
      if(this.selected.hub) {
        this.readonly = false;
      }
    }
  }
};
</script>

<style>

</style>
